import React from "react";

const DownloadLink = (props) => {
  return (
    <a
      style={{ textAlign: "right", display: "block", marginBottom: "20px" }}
      target="_blank"
      rel="noopener noreferrer"
      href={props.src}
      download
    >
      {props.children}
    </a>
  );
};

export default React.memo(DownloadLink);
